import React from 'react';
import { Outlet } from 'react-router-dom';

export function ReCommerceLayout() {
  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 overflow-auto bg-neutral-50">
        <Outlet />
      </div>
    </div>
  );
} 